import React from 'react';

import './style.scss';
import image from '../../../assets/images/invalid.png';

const ErrorMessageScreen = (props) => {
  const { text, showSupportText } = props;

  return (
    <div className='error-main-container'>
      <img src={image} alt='invalid' />
      <div className='error-container'>
        <p className='error-p1'>{text}</p>
        {showSupportText && (
          <p className='error-p2'>
            Please try again or reach out to us at support@logiqids.com
          </p>
        )}
      </div>
    </div>
  );
};

export default ErrorMessageScreen;
